export default {
  CHOOSE: 'Choose all that apply',
  COMPANY: 'Company'
}